import { appStyles, logoImage } from './app.style'

export const ContainerApp = ({ children }: { children: React.ReactNode }) => {
	return (
		<div style={{
			...appStyles.container,
			height: '100vh',
			display: 'flex',
			flexDirection: 'column',
			overflow: 'hidden'
		}}>
			{children}
		</div>
	)
}

export const ContentApp = ({ children }: { children: React.ReactNode }) => {
	return (
		<div style={{
			flex: 1,
			overflowY: 'auto',
			padding: '20px',
			width: '90%',
			minHeight: 0 // Importante para que funcione el scroll en flexbox
		}}>
			{children}
		</div>
	)
}

export const FooterApp = ({
	justifyContent = 'space-evenly', 
	children 
}: { 
	justifyContent?: 'space-evenly' | 'space-between | end', 
	children: React.ReactNode 
}) => {
	return (
		<div
			id='wizard-nav' 
			style={{
				width: '100%', 
				display: 'flex', 
				justifyContent: justifyContent,
				padding: '20px',
				backgroundColor: 'white',
				borderTop: '1px solid #e0e0e0',
				zIndex: 1000
			}}
		>
			{children}
		</div>
	)
}

export const HeaderApp = ({ title }: { title: string }) => {

	return (
		<>
		<div 
			style={{
				padding: '0',
				margin: '0',
				borderBottom: '1px solid #e0e0e0',

			}}
		>
			<div
				id='app-header' 
				style={{
					...appStyles.logoContainer,
					backgroundColor: 'white',
					zIndex: 1000
				}}
			
			>
				<img src={logoImage} alt="logo" style={appStyles.logo} />
				<div style={{ padding: '0', paddingLeft: '6px', margin: '0', width: 'inherit'}}>
					<h1>Kaiteki</h1>
					<h3>Salud, estés donde estés</h3>
				</div>
			</div>
			<h1>{title}</h1>
		</div>
		</>
)}

export const LabelApp = ({ label }: { label: string }) => {
	return (
		<label style={{paddingLeft: '10px'}}>{label}</label>
	)
}